import MainUser from "../components/create-user/mainUser";

function CreateUser() {
    return(<div><MainUser/></div>)
}

export default CreateUser;